import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const RotateCw: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M21 2v6h-6' }],
    ['path', { d: 'M21 13a9 9 0 1 1-3-7.7L21 8' }],
  ],
];

export default RotateCw;
